import React, { useEffect, useState } from 'react';
import ProductCard from '../ProductCard/ProductCard';
import './index.css';
import axios from 'axios';
import { FaSearch } from 'react-icons/fa';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState([]);  // Declare ratings state
 
  const [loading, setLoading] = useState(true);

 
 
  const fetchRatings = (productId) => {
    return axios.get(`https://api.lbnhyderabad.com/product/products/${productId}/ratings`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching ratings:', error);
        return []; // Return empty array if error occurs
      });
  };


  // useEffect(() => {
  //   fetch('https://api.lbnhyderabad.com/product/show-all-data')
  //     .then(response => response.json())
  //     .then(data => {
  //       if (Array.isArray(data)) {
  //         setProducts(data); // If it's already an array
  //       } else if (data && Array.isArray(data.products)) {
  //         setProducts(data.products); // If products are inside a "products" key
  //       } else {
  //         setProducts([]); // Default to empty array
  //       }
  //     })
  //     .catch(error => console.error('Error fetching products:', error));
  // }, []);


  
    const [shuffledProducts, setShuffledProducts] = useState([]);
  
  const shuffleArray = (array) => {
    return array
      .map((item) => ({ item, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ item }) => item);
  };
  

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        // Fetch products from the API
        const response = await axios.get('https://api.lbnhyderabad.com/product/show-all-data');
        
        // If data contains products, start processing
        if (Array.isArray(response.data)) {
          // Fetch ratings for each product in parallel using Promise.all
          const updatedProducts = await Promise.all(
            response.data.map(async (product) => {
              const ratings = await fetchRatings(product.id); // Fetch ratings asynchronously
              return {
                ...product,
                ratings, // Attach fetched ratings to the product
              };
            })
          );

          const combined = [ ...updatedProducts];
          const shuffled = shuffleArray(combined);
      
          
          setProducts(updatedProducts); // Set products with ratings
          setShuffledProducts(shuffled);
        } else if (response.data && Array.isArray(response.data.products)) {
          const updatedProducts = await Promise.all(
            response.data.products.map(async (product) => {
              const ratings = await fetchRatings(product.id); // Fetch ratings asynchronously
              return {
                ...product,
                ratings, // Attach fetched ratings to the product
              };
            })
          );

          
          setProducts(updatedProducts); // Set products with ratings
          //setShuffledProducts(shuffled);
        } else {
          setProducts([]); // If no products, set an empty array
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        setProducts([]); // Set empty products on error
      } finally {
        setLoading(false); // Set loading to false after fetching is done
      }
    };

    fetchProducts(); // Call fetchProducts on component mount
  }, []); 


  useEffect(() => {
   
    fetchRatings();

  }, []);


    const [searchTerm, setSearchTerm] = useState("");
    const filteredProducts = shuffledProducts.filter((product) => {
      const name = product.productName.toLowerCase();
      const desc = product.productDesc.toLowerCase();
      const term = searchTerm.toLowerCase();
      return name.includes(term) || desc.includes(term);
    });
    

  // return (
  //   <div className="product-list-container">
  //     {/* Header */}
  //     <h1 className="product-list-header">Products</h1>
  //     <div className="search-bar" style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
  //       <input
  //         type="text"
  //         placeholder="Search products..."
  //         value={searchTerm}
  //         onChange={(e) => setSearchTerm(e.target.value)}
  //         style={{
  //           flex: 1,
  //           padding: "10px 15px",
  //           borderRadius: "5px",
  //           border: "1px solid #ccc",
  //           fontSize: "16px",
  //         }}
  //       />
  //       <FaSearch style={{ marginLeft: "-30px", color: "#888" }} />
  //     </div>
  //     {/* Product list */}
  //     <div className="product-list">
  //       {Array.isArray(filteredProducts) && filteredProducts.length > 0 ? (
  //         filteredProducts.map((product) => (
  //           <ProductCard key={product.id} product={product}  ratings={product.ratings || []} />
  //         ))
  //       ) : (
  //         <p>No products available.</p>
  //       )}
  //     </div>
  //   </div>
  // );

return (
  <div
    style={{
      width: "100%",
      padding: "30px 20px",
      background: "#f8fafc",
    }}
  >
    {/* HEADER */}
    <div
      style={{
        textAlign: "center",
        marginBottom: "40px",
      }}
    >
      <h1
        style={{
          fontSize: "clamp(28px,5vw,52px)",
          fontWeight: "800",
          color: "#1e3a8a",
          marginBottom: "15px",
        }}
      >
        Our Products & Services
      </h1>

      <p
        style={{
          color: "#64748b",
          fontSize: "clamp(14px,2vw,18px)",
          maxWidth: "700px",
          margin: "auto",
          // lineHeight: "30px",
        }}
      >
        Discover premium business solutions from our network of professional members
      </p>

      {/* SEARCH */}
      <div
        style={{
          width: "100%",
          maxWidth: "700px",
          margin: "35px auto 0px",
          position: "relative",
        }}
      >
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "18px 55px 18px 20px",
            borderRadius: "50px",
            border: "2px solid #dbeafe",
            outline: "none",
            fontSize: "16px",
            background: "#fff",
            boxSizing: "border-box",
          }}
        />

        <FaSearch
          style={{
            position: "absolute",
            right: "22px",
            top: "50%",
            transform: "translateY(-50%)",
            color: "#1e3a8a",
            fontSize: "18px",
          }}
        />
      </div>
    </div>

    {/* PRODUCTS GRID */}
    <div
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
        gap: "30px",
        padding:"25px",
        
      }}
    >
      {Array.isArray(filteredProducts) &&
      filteredProducts.length > 0 ? (
        filteredProducts.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            ratings={product.ratings || []}
          />
        ))
      ) : (
        <p>No products available.</p>
      )}
    </div>
  </div>
);
};


export default ProductList;
